import React from "react";
import useIsMobile from "../hooks/useIsMobile";
import AccountMastersMobile from "../mobile/logistics/AccountMastersMobile";
import AccountMasterManager from "./components/AccountMasterManager";

export default function ResponsiveAccountMasterManager(props) {
  return useIsMobile() ? <AccountMastersMobile {...props} /> : <AccountMasterManager {...props} />;
}
